import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";

export const AdminLayout = () => (
  <div className="flex h-full overflow-hidden">
    <AdminSidebar />
    <div className="flex-1 overflow-auto">
      <Outlet />
    </div>
  </div>
);
